import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Box, TextField} from "@mui/material";
import {Add, Edit} from "@mui/icons-material";
import {useTheme} from "@mui/material/styles";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import {IVoceCosto} from "../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceCosto";
import useApiGetVociCosto from "./api-hooks/useApiGetVociCosto";
import useApiGetVoceCostoDetail from "./api-hooks/useApiGetVoceCostoDetail";
import Loading from "../../../../../ui/Loading";
import MuiAutocomplete from "../../../../../ui/mui/mui-input/MuiAutoComplete";
import MRTMuiButton from "../../../../../ui/mui/mui_react_table/MRTMuiButton";
import MuiModal from "../../../../../ui/mui/mui_modal/MuiModal";
import VociCostoForm from "./VociCostoForm";
import VociCostoTable from "./VociCostoTable";


interface Props {
    obj: IVoceCosto | undefined,
    onChange: (obj: IVoceCosto | undefined) => void,
    className: string,
    label?: string,
    required?: boolean
    withDefaultValueIfEmpty?: boolean
}

const VociCostoSelect = ({
                             obj: initialObj,
                             label,
                             onChange,
                             required,
                             withDefaultValueIfEmpty = false,
                         }: Props) => {


    const theme = useTheme();
    const {t} = useTranslation()

    const [isEditFormOpen, setIsEditFormOpen] = useState<boolean>(false)
    const [isListTableOpen, setIsListTableOpen] = useState<boolean>(false)


    const [objs, setObjs] = useState<IVoceCosto[]>([]);
    const [obj, setObj] = useState<IVoceCosto | undefined>(initialObj)


    useEffect(() => {
        setObj(undefined);
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj]);


    const {
        data,
        isLoading,
    } = useApiGetVociCosto();


    useEffect(() => {
        if (data) {
            setObjs(data)
            if (!initialObj && data.length > 0 && withDefaultValueIfEmpty) {
                setObj(data[0]);
                onChange(data[0]);
            }
        }
    }, [data]);


    const {
        data: detailedObj,
    } = useApiGetVoceCostoDetail(obj?.id);


    useEffect(() => {
        if (detailedObj) {
            setObj(detailedObj);
        }
    }, [detailedObj]);

    const handleOnChange = (event: React.SyntheticEvent, newValue: IVoceCosto | null) => {
        if (newValue) {
            onChange(newValue);
        } else {
            onChange(undefined);
        }
    };

    const handleChange = (obj: IVoceCosto | undefined) => {
        setObj(obj);
        onChange(obj)
    }

    useEffect(() => {
        onChange(obj);

    }, [obj]);


    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Box sx={{alignItems: 'center', width: '100%'}}>
                        <MuiAutocomplete
                            id="voce_costo-select"
                            options={objs}
                            getOptionLabel={(option) => option.name}
                            value={detailedObj ? detailedObj : null}
                            onChange={handleOnChange}
                            isOptionEqualToValue={(option, value) => option.id === value?.id && option.name === value?.name}
                            renderInput={(params) => (
                                <TextField
                                    sx={{textTransform: 'capitalize'}}
                                    {...params}
                                    label={label ? t(label) : '' || t('voce costo')}
                                    required={required}
                                />
                            )}
                            borderColor={theme.palette.primary.light}
                            onFocusBorderColor={theme.palette.primary.dark}
                            minWidth={300}
                        >

                            <MRTMuiButton
                                icon={<FormatListBulletedIcon sx={{color: theme.palette.primary.main}}/>}
                                onClick={() => setIsListTableOpen(true)}
                                small={true}
                                label={'show_list'}
                            />
                            <MRTMuiButton
                                icon={obj ? <Edit sx={{color: theme.palette.primary.main}}/> :
                                    <Add sx={{color: theme.palette.primary.main}}/>}
                                onClick={() => setIsEditFormOpen(true)}
                                small={true}
                                label={obj ? 'edit' : 'add'}
                            />
                        </MuiAutocomplete>
                    </Box>

                    <MuiModal
                        top="50%"
                        left="50%"
                        width={'50vh'}
                        open={isEditFormOpen}
                        onClose={() => setIsEditFormOpen(false)}
                    >
                        <VociCostoForm objToEdit={obj ? obj : null}
                                       onSelect={onChange}
                                       onClose={() => setIsEditFormOpen(false)}
                        />
                    </MuiModal>

                    <MuiModal top="50%" left="50%" width={'120vh'} open={isListTableOpen}
                              onClose={() => setIsListTableOpen(false)}
                              disableBackdropClick={true}
                    >
                        <VociCostoTable
                            onSelect={handleChange}
                            onClose={() => setIsListTableOpen(false)}
                        />
                    </MuiModal>

                </>
            )}
        </>
    );
}

export default VociCostoSelect;